import { render } from "./HelpModalBox.vue?vue&type=template&id=376c4af0&scoped=true"
import script from "./HelpModalBox.vue?vue&type=script&lang=js"
export * from "./HelpModalBox.vue?vue&type=script&lang=js"

import "./HelpModalBox.vue?vue&type=style&index=0&id=376c4af0&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376c4af0"]])

export default __exports__